import React, { useState, useEffect } from 'react';
import api from "../../../../../../services/api";

import Select2 from "react-select2-wrapper";
import {
    Button,
    Row,
    Col,
    Input,
    FormGroup,
    InputGroup,
    InputGroupAddon,
} from "reactstrap";

export default ({ notify, funilId, empresaId, close, onSuccess, tipoFixo = null, ...props }) => {

    const [nome, setNome] = useState(null)
    const [situacao, setSituacao] = useState('A')
    const [descricao, setDescricao] = useState(null)
    const [tipo, setTipo] = useState(tipoFixo)
    const [pastaId, setPastaId] = useState(null)

    const [pastas, setPastas] = useState([])
    const [showNovaPasta, setShowNovaPasta] = useState(false)
    const [novaPastaNome, setNovaPastaNome] = useState('')
    const [salvandoPasta, setSalvandoPasta] = useState(false)

    const [funil, setFunil] = useState({})
    const [erros, setErros] = useState({})


    useEffect(() => {
        if (funilId && funilId != funil.id) {
            loadFunil(funilId)
        }
    }, [funilId])

    useEffect(() => {
        if (empresaId) loadPastas()
    }, [empresaId])

    useEffect(() => {
        setNome(funil.nome)
        setSituacao(funil.situacao ? funil.situacao : 'A')
        setDescricao(funil.descricao)
        setTipo(tipoFixo || funil.tipo || null)
        setPastaId(funil.pasta_id || null)
    }, [funil, tipoFixo])

    async function loadFunil(funilId) {
        try {
            const response = await api.get(`/common/empresas/${empresaId}/funis/${funilId}`)
            if (response.data) {
                setFunil(response.data)
            }
            updateErros(null)
        } catch (error) {
            console.log(error)
        }
    }

    async function loadPastas() {
        try {
            const response = await api.get(`/common/empresas/${empresaId}/pastas-funis`, {
                params: { situacao: 'A' }
            })
            const lista = response.data?.data || response.data || []
            setPastas(lista)
            if (!funilId && !pastaId && lista.length > 0) {
                setPastaId(lista[0].id)
            }
        } catch (error) {
            console.log(error)
            if (notify) notify('danger', 'Não foi possível carregar as pastas')
        }
    }

    async function handleCriarPasta() {
        const nomePasta = (novaPastaNome || '').trim()
        if (!nomePasta) {
            if (notify) notify('warning', 'Informe o nome da pasta')
            return
        }
        try {
            setSalvandoPasta(true)
            const response = await api.post(`/common/empresas/${empresaId}/pastas-funis`, {
                nome: nomePasta,
                situacao: 'A',
            })
            const novaPasta = response.data?.pasta
            await loadPastas()
            if (novaPasta?.id) setPastaId(novaPasta.id)
            setShowNovaPasta(false)
            setNovaPastaNome('')
            if (notify) notify('success', 'Pasta criada com sucesso')
        } catch (error) {
            console.error(error)
            const msg = error.response?.data?.message || 'Não foi possível criar a pasta'
            if (notify) notify('danger', msg)
        } finally {
            setSalvandoPasta(false)
        }
    }


    function handleSave() {
        if (funilId) {
            update()
        } else {
            insert()
        }
    }

    async function insert() {
        try {
            await api.post(`/common/empresas/${empresaId}/funis`, {
                nome,
                situacao,
                descricao,
                tipo,
                pasta_id: pastaId,
            })
            updateErros(null)
            if (onSuccess) onSuccess()
        } catch (error) {
            console.error(error)
            if (notify) notify('danger', 'Não foi possível adicionar o funil')
            if (error.response) updateErros(error.response.data)
        }
    }

    async function update() {
        try {
            await api.put(`/common/empresas/${empresaId}/funis/${funilId}`, {
                nome,
                situacao,
                descricao,
                tipo,
                pasta_id: pastaId,
            })
            updateErros(null)
            if (onSuccess) onSuccess()
        } catch (error) {
            console.error(error)
            if (notify) notify('danger', 'Não foi possível salvar o funil')
            if (error.response) updateErros(error.response.data)
        }
    }

    function updateErros(error) {
        if (error && error instanceof Array) {
            const errors = {}
            for (let e of error) {
                errors[e.field] = e.message
            }
            setErros(errors)
        } else {
            setErros({})
        }
    }

    return (
        <>
            <Row>
                <Col>
                    <FormGroup>
                        <label
                            className="form-control-label"
                        >
                            Nome*
                        </label>
                        <Input
                            className="form-control"
                            placeholder="Nome..."
                            type="text"
                            value={nome}
                            onChange={(e) => setNome(e.target.value)}
                        />
                        <small class="text-danger">
                            {erros.nome ? erros.nome : ''}
                        </small>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <label
                            className="form-control-label"
                            title={(funilId && funil.fl_ispadraoempresa) ? 'Funil configurado como padrão não pode ser inativado!' : ''}
                        >
                            Situação*
                        </label>
                        <Select2
                            defaultValue="A"
                            onSelect={(e) => setSituacao(e.target.value)}
                            options={{
                                disabled: (funilId && funil.fl_ispadraoempresa),
                                placeholder: "Selecione uma situação..."
                            }}
                            value={situacao}
                            data={
                                [
                                    {
                                        id: 'A',
                                        text: 'Ativo'
                                    }, {
                                        id: 'I',
                                        text: 'Inativo'
                                    }
                                ]
                            }
                        />
                        <small class="text-danger">
                            {erros.situacao ? erros.situacao : ''}
                        </small>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <label className="form-control-label">
                            Pasta*
                        </label>
                        <InputGroup>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <Select2
                                    onSelect={(e) => setPastaId(Number(e.target.value))}
                                    options={{ placeholder: "Selecione a pasta..." }}
                                    value={pastaId || ''}
                                    data={pastas.map(p => ({ id: p.id, text: p.nome }))}
                                />
                            </div>
                            <InputGroupAddon addonType="append">
                                <Button
                                    color="primary"
                                    type="button"
                                    onClick={() => setShowNovaPasta(!showNovaPasta)}
                                    title="Criar nova pasta"
                                >
                                    <i className="ni ni-fat-add" />
                                </Button>
                            </InputGroupAddon>
                        </InputGroup>
                        <small className="text-danger">
                            {erros.pasta_id ? erros.pasta_id : ''}
                        </small>

                        {showNovaPasta && (
                            <div className="mt-2 p-3 border rounded bg-secondary">
                                <label className="form-control-label">
                                    Nome da nova pasta
                                </label>
                                <Input
                                    className="form-control mb-2"
                                    placeholder="Ex.: Vendas, Suporte..."
                                    type="text"
                                    value={novaPastaNome}
                                    onChange={(e) => setNovaPastaNome(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault()
                                            handleCriarPasta()
                                        }
                                    }}
                                />
                                <div className="text-right">
                                    <Button
                                        color="link"
                                        size="sm"
                                        type="button"
                                        onClick={() => {
                                            setShowNovaPasta(false)
                                            setNovaPastaNome('')
                                        }}
                                    >
                                        Cancelar
                                    </Button>
                                    <Button
                                        color="primary"
                                        size="sm"
                                        type="button"
                                        disabled={salvandoPasta}
                                        onClick={handleCriarPasta}
                                    >
                                        {salvandoPasta ? 'Salvando...' : 'Salvar pasta'}
                                    </Button>
                                </div>
                            </div>
                        )}
                    </FormGroup>
                </Col>
            </Row>
            {!tipoFixo && (
                <Row>
                    <Col>
                        <FormGroup>
                            <label className="form-control-label">
                                Tipo*
                            </label>
                            <Select2
                                onSelect={(e) => setTipo(e.target.value)}
                                options={{ placeholder: "Selecione o tipo..." }}
                                value={tipo}
                                data={[
                                    { id: 'crm', text: 'CRM' },
                                    { id: 'pipeline', text: 'Pipeline' },
                                ]}
                            />
                            <small className="text-danger">
                                {erros.tipo ? erros.tipo : ''}
                            </small>
                        </FormGroup>
                    </Col>
                </Row>
            )}
            <Row>
                <Col>
                    <FormGroup>
                        <label
                            className="form-control-label"
                        >
                            Descrição
                        </label>
                        <Input
                            className="form-control"
                            placeholder="Descrição..."
                            type="textarea"
                            rows={3}
                            value={descricao}
                            onChange={(e) => setDescricao(e.target.value)}
                        />
                        <small class="text-danger">
                            {erros.descricao ? erros.descricao : ''}
                        </small>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="float-right ">
                        <Button
                            className="ml-auto"
                            color="link"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => close()}
                        >
                            Fechar
                        </Button>
                        <Button
                            color="primary"
                            onClick={handleSave}
                        >
                            Salvar
                        </Button>
                    </div>
                </Col>
            </Row>
        </>
    );
}
